setCustomAttribute